<template>
  <div>
    <v-text-field
      ref="input"
      v-model="keyword"
      @click:append="onIconClick"
      @click:clear="clearSearch"
      @keydown.native.enter="onEnter"
      @keydown.native.stop.esc="clearSearch"
      @keyup.native.stop.arrow-down="onArrowDown"
      @keyup.native.stop.arrow-up="onArrowUp"
      @compositionstart="usingIME = true"
      @compositionend="usingIME = false"
      label="地名、緯度経度を入力して検索"
      append-icon="search"
      single-line
      clearable
      hide-details
      dense
    />
  </div>
</template>

<script>
export default {
  name: 'SimulationContentDeliverySearchInput',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      usingIME: false,
    }
  },
  computed: {
    keyword: {
      get() {
        return this.value
      },
      set(keyword) {
        this.$emit('change', keyword)
      },
    },
  },
  methods: {
    onIconClick() {
      this.$emit('iconClick')
    },
    onEnter() {
      // 文字入力確定時のEnterは無視する
      if (this.usingIME) {
        return false
      }
      this.$emit('enter')
    },
    clearSearch() {
      this.clearKeyword()
      this.$emit('clear')
    },
    onArrowDown() {
      this.$emit('arrowDown')
    },
    onArrowUp() {
      this.$emit('arrowUp')
    },
    clearKeyword() {
      this.keyword = ''
    },
  },
}
</script>

<style scoped>
::v-deep .v-text-field {
  padding-top: 0;
  margin-top: 0;
}
</style>
